import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addValidation, removeValidation } from 'state/slices/validationSlice';

import { VALIDATION_MESSAGES } from 'utils/constants/validation-messages';

const VALIDATION_ID = 'lockdown-verification-failed' as const;
const VALIDATION_TYPE = 'verification-lockdown' as const;

const LOCKDOWN_VALIDATION = {
  id: VALIDATION_ID,
  message: VALIDATION_MESSAGES.LOCKDOWN_APPLICATION_DUE_TO_FAILED_VERIFICATION,
  type: VALIDATION_TYPE,
  isValid: false,
} as const;

export const useVerificationValidation = (shouldDisableNavigation: boolean): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (shouldDisableNavigation) {
      dispatch(addValidation(LOCKDOWN_VALIDATION));
    } else {
      dispatch(removeValidation(VALIDATION_ID));
    }
  }, [shouldDisableNavigation, dispatch]);
};
